// src/utils/image/cropAndResize.js
export async function cropToSquareAndResize(file, {
  maxSize = 512,
  mimeType = 'image/webp',
  quality = 0.9,
} = {}) {
  const dataUrl = await readAsDataURL(file);
  const img = await loadImage(dataUrl);

  const w = img.naturalWidth || img.width;
  const h = img.naturalHeight || img.height;
  const side = Math.min(w, h);
  const sx = Math.floor((w - side) / 2);
  const sy = Math.floor((h - side) / 2);

  const crop = document.createElement('canvas');
  crop.width = side;
  crop.height = side;
  const cctx = crop.getContext('2d');
  cctx.imageSmoothingEnabled = true;
  cctx.imageSmoothingQuality = 'high';
  cctx.drawImage(img, sx, sy, side, side, 0, 0, side, side);

  const out = document.createElement('canvas');
  out.width = maxSize;
  out.height = maxSize;
  const octx = out.getContext('2d');
  octx.imageSmoothingEnabled = true;
  octx.imageSmoothingQuality = 'high';
  octx.drawImage(crop, 0, 0, maxSize, maxSize);

  const blob = await canvasToBlob(out, mimeType, quality);
  const outDataUrl = await blobToDataURL(blob);

  return { blob, dataUrl: outDataUrl, width: maxSize, height: maxSize, format: mimeType };
}

function readAsDataURL(file) {
  return new Promise((res, rej) => {
    const fr = new FileReader();
    fr.onload = () => res(fr.result);
    fr.onerror = rej;
    fr.readAsDataURL(file);
  });
}

function loadImage(src) {
  return new Promise((res, rej) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => res(img);
    img.onerror = rej;
    img.src = src;
  });
}

function canvasToBlob(canvas, type, quality) {
  return new Promise((res) => {
    if (canvas.toBlob) canvas.toBlob((b) => res(b), type, quality);
    else {
      const dataUrl = canvas.toDataURL(type, quality);
      const [meta, base64] = dataUrl.split(',');
      const mime = meta.match(/:(.*?);/)[1];
      const bin = atob(base64);
      const len = bin.length;
      const u8 = new Uint8Array(len);
      for (let i = 0; i < len; i++) u8[i] = bin.charCodeAt(i);
      res(new Blob([u8], { type: mime }));
    }
  });
}

function blobToDataURL(blob) {
  return new Promise((res) => {
    const fr = new FileReader();
    fr.onload = () => res(fr.result);
    fr.readAsDataURL(blob);
  });
}
